(async () => {
  if (!customElements.get('tiles-slider')) {
    const { default: Swiper, A11y, Navigation } = await import('swiper');

    Swiper.use([A11y, Navigation]);

    class TilesSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector('[data-swiper]');

        // Stop when the swiper is not found
        if (!this.swiper) return;

        // Check if we have extra options on the HTML
        if (this.swiper.dataset && this.swiper.dataset.options) {
          const jsonOptions = JSON.parse(this.swiper.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...jsonOptions,
            };
          }
        }

        // Call swiper with selected swiper element and options
        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);
      }

      connectedCallback() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
        this.observer.observe(this);
        this.options = [];
        this.querySelectorAll('.swiper-slide').forEach((slide, index) => {
          this.options.push({
            title: slide.querySelector('.text-base')?.textContent.trim() || 'undefined',
            imageName: slide.querySelectorAll('img')[0]?.title || 'undefined',
            imageAlt: slide.querySelectorAll('img')[0]?.alt || 'undefined',
            position: index + 1,
            link: slide.href || 'undefined',
          });
          slide.addEventListener('click', this.handleClick.bind(this));
        });
      }

      handleIntersection(entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'TilesSlider',
              pageType:
                document.querySelector('[data-template-class]').dataset.templateClass ||
                'undefined',
              pageURL: window.location.href || 'undefined',
              options: this.options,
            });
            debug() && console.log('TilesSlider: ', this.options, window.dataLayer);
            observer.unobserve(entry.target);
          }
        });
      }

      handleClick() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'TilesSliderClick',
          pageType:
            document.querySelector('[data-template-class]').dataset.templateClass || 'undefined',
          pageURL: window.location.href || 'undefined',
          options: this.options,
        });
        debug() && console.log('TilesSliderClick: ', this.options, window.dataLayer);
      }
    }
    window.TilesSlider = TilesSlider;

    customElements.define('tiles-slider', TilesSlider);
  }
})();
